
import React from "react";
import { Calendar } from "lucide-react";

interface CampaignDateRangeProps {
  startDate: string;
  endDate: string;
}

const CampaignDateRange = ({ startDate, endDate }: CampaignDateRangeProps) => {
  return (
    <div className="flex items-center text-sm text-gray-600">
      <Calendar className="h-3.5 w-3.5 mr-1.5 text-gray-400" />
      <div className="space-y-0.5">
        <div>{new Date(startDate).toLocaleDateString('pt-BR')}</div>
        <div className="text-xs text-gray-500">
          até {new Date(endDate).toLocaleDateString('pt-BR')}
        </div>
      </div>
    </div>
  );
};

export default CampaignDateRange;
